import type { QueryKey } from '@tanstack/react-query';
import { get } from '../../../../redux/api';
import { useQuery } from '../../../../ReactQuery';
import type { GetTeamGroupsResponse } from '../../../../../shared/types/routes/teamGroups';

//  Actual function to fetch team groups
function fetchTeamGroups() {
  return get<GetTeamGroupsResponse>('/api/teams/groups');
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
export const useTeamGroupsQueryKey: QueryKey = ['teams', 'groups'];

/**
 * useTeamGroups is a hook that fetches and returns the team groups the
 * current user has access to from /api/teams/groups.
 *
 * @param {boolean} shouldFetch - Whether to fetch the team groups.
 */
export default function useTeamGroups(shouldFetch: boolean = true) {
  return useQuery<GetTeamGroupsResponse>({
    queryKey: useTeamGroupsQueryKey,
    queryFn: fetchTeamGroups,
    enabled: shouldFetch,
  });
}
